import { findUserSavedFilterEqualToDashboardFilterFunction } from '../../../services/utilities/utilities';

export const getters = {
    getSelectedFiltersFromLayerIds: (state, _getters) => (layerIds) => {
        const filtersToApply = [];
        layerIds.forEach((id) => {
            const layerObject = _getters.getLayerById(id);
            // make a copy to prevent mutating data in the store
            const layerFilters = JSON.parse(
                JSON.stringify(layerObject.filters)
            );
            const filterSettings = layerFilters.settings;
            filterSettings
                .map((setting) => {
                    // since changed filters get a new ID in the database we update the id in the userMap
                    const foundUserMapFilterEqualToDashboardFilter =
                        layerFilters.data.find(({ settings }) =>
                            findUserSavedFilterEqualToDashboardFilterFunction(
                                [setting.data]
                            )(settings)
                        );
                    if (foundUserMapFilterEqualToDashboardFilter) {
                        const filterId =
                            foundUserMapFilterEqualToDashboardFilter
                                .settings.id;
                        return {
                            ...setting,
                            filterId,
                            data: {
                                ...setting.data,
                                filterId,
                                filter: {
                                    ...setting.data.filter,
                                    id: filterId
                                }
                            }
                        };
                    }
                    return setting;
                })
                .forEach((setting) => {
                    const filterToApply = {
                        themeId: layerObject.data.themeId,
                        layerId: id,
                        filterId: setting.data.filterId,
                        filter: setting.data.filter
                    };
                    filtersToApply.push(filterToApply);
                });
        });
        return filtersToApply;
    },
    getDefaultFilters: (state) => {
        return state.defaultFilters;
    },
};
